import auth0 from 'auth0-js';

let auth0ClientFactory = configService => {
  return {
    build: () => {
      return configService.load()
        .then(() => {
          const config = {
            clientID: configService.get('auth0.clientId'),
            domain: configService.get('auth0.domain'),
            audience: configService.get('appUrl') + '/api',
            scope: 'openid profile email',
            responseType: 'token id_token',
            redirectUri: configService.get('appUrl') + '/loading'
          };

          return new auth0.WebAuth(config);
        });
    }
  };
};

auth0ClientFactory.$inject = [ 'configService' ];

export default auth0ClientFactory;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/journey-ui/auth/services/auth0ClientFactory.service.js